import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {Button} from 'primereact/button';
import {ProgressBar} from 'primereact/progressbar';

const RecruitmentShowComponent = (props) => {

  const {t} = props;

  const [loading, setLoading] = useState(false);
  const [eventTypes, setEventTypes] = useState([]);

  useEffect(() => {
    loadEventTypes();
  }, []);

  const loadEventTypes = () => {
    setLoading(true);

    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/recruitment-event-type?item_per_page=100', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId')
      }
    })
      .then((response) => {
        const items = response.data?.data?.items || [];
        setEventTypes(items);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (window.App && window.App.toastShow) {
          window.App.toastShow('error', t('toastError'), t('eventTypesLoadError'), 3000, error.response);
        }
      });
  };

  const getReadableTextColor = (hexColor) => {
    if (!hexColor) {
      return '#ffffff';
    }

    const color = hexColor.replace('#', '');

    if (color.length !== 6) {
      return '#ffffff';
    }

    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);

    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return brightness > 160 ? '#222222' : '#ffffff';
  };

  const editEventType = (eventType) => {
    if (window.App && window.App.setState) {
      window.App.setState({
        sidebarRecruitmentEventtypeUpdate: true,
        props: {
          id: eventType.id
        }
      });
    }
  };

  return (
    <div className="recruitment-eventtype-show">

      {loading && (
        <ProgressBar mode="indeterminate" style={{height: '6px'}}/>
      )}

      {!loading && eventTypes.length === 0 && (
        <div className="p-mt-3">
          {t('noDisplayableEventType')}
        </div>
      )}

      {eventTypes.map((eventType) => {
        const backgroundColor = eventType.color || '#3498db';
        const textColor = getReadableTextColor(backgroundColor);
        const statuses = eventType.statuses || [];

        return (
          <div
            key={eventType.id}
            className="eventtype-show-card"
            style={{
              backgroundColor: backgroundColor,
              color: textColor,
              marginBottom: '1.5rem',
              borderRadius: '2px',
              overflow: 'hidden'
            }}
          >
            <div
              className="eventtype-show-header"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1rem 1.25rem',
                borderBottom: '1px solid rgba(255,255,255,0.35)'
              }}
            >
              <h3
                style={{
                  margin: 0,
                  color: textColor,
                  fontSize: '1.25rem',
                  fontWeight: 700
                }}
              >
                {eventType.name}
              </h3>

              <Button
                tooltip={t('edit')}
                icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                onClick={() => editEventType(eventType)}
              />
            </div>

            <div
              className="eventtype-show-body"
              style={{
                padding: '1rem 1.25rem',
                borderBottom: '1px solid rgba(255,255,255,0.35)'
              }}
            >
              <div style={{fontWeight: 700}}>
                {t('eventProfiles')}
              </div>

              <div>
                {statuses.length > 0 ? (
                  <>
                    {t('activeProfileCount')}: {statuses.length}
                  </>
                ) : (
                  <>
                    {t('noActiveEventProfile')}
                  </>
                )}
              </div>
            </div>

            <div
              className="eventtype-show-footer"
              style={{
                minHeight: '2.5rem'
              }}
            />
          </div>
        );
      })}

    </div>
  );
};

export default withTranslation('common')(RecruitmentShowComponent);
